import { TwainGameId } from 'betgames-contract-js';

export const rooms = {
    getGameInfoRoom: (gameId: TwainGameId) => `room:gameInfo:${gameId}`,
};
